import {
  LIVE_LEDGER_ACCOUNT_QUERY_KEY,
  LIVE_LEDGER_AMOUNT_MAX_QUERY_KEY,
  LIVE_LEDGER_AMOUNT_MIN_QUERY_KEY,
  LIVE_LEDGER_BAI_CODES_QUERY_KEY,
  LIVE_LEDGER_CATEGORY_QUERY_KEY,
  LIVE_LEDGER_DATE_FROM_QUERY_KEY,
  LIVE_LEDGER_DATE_TO_QUERY_KEY,
  LIVE_LEDGER_METHOD_QUERY_KEY,
  LIVE_LEDGER_SEARCH_QUERY_KEY,
  LIVE_LEDGER_TYPE_QUERY_KEY,
} from "../../constants";

export type TransactionLedgerFilterId =
  | "saved-filters"
  | "accounts"
  | "date-range"
  | "category"
  | "bai-codes"
  | "type"
  | "amount"
  | "method";

const FILTER_QUERY_KEYS: Record<TransactionLedgerFilterId, string[]> = {
  "saved-filters": [],
  accounts: [LIVE_LEDGER_ACCOUNT_QUERY_KEY],
  "date-range": [
    LIVE_LEDGER_DATE_FROM_QUERY_KEY,
    LIVE_LEDGER_DATE_TO_QUERY_KEY,
  ],
  category: [LIVE_LEDGER_CATEGORY_QUERY_KEY],
  "bai-codes": [LIVE_LEDGER_BAI_CODES_QUERY_KEY],
  type: [LIVE_LEDGER_TYPE_QUERY_KEY],
  amount: [LIVE_LEDGER_AMOUNT_MIN_QUERY_KEY, LIVE_LEDGER_AMOUNT_MAX_QUERY_KEY],
  method: [LIVE_LEDGER_METHOD_QUERY_KEY],
};

export const queryKeysForFilters = (
  filterIds: TransactionLedgerFilterId[],
  searchEnabled: boolean
): string[] => {
  const keys = filterIds.flatMap((id) => FILTER_QUERY_KEYS[id]);
  return searchEnabled ? [...keys, LIVE_LEDGER_SEARCH_QUERY_KEY] : keys;
};
